import * as $ from "jquery";

// Some common form javascript functions
export module FormTools {
    export function getToday(): string {
        const today = new Date();
        const month = today.getMonth() + 1;
        const day = today.getDate();
        const year = today.getFullYear();
        return `${month}/${day}/${year}`;
    }

    export function updateTextActive($text: JQuery, active: boolean) {
        if (!active) {
            $text.data("oldtext", $text.val() ?? "");
            $text.val("");
        } else {
            const oldtext = $text.data("oldtext");
            if (oldtext) {
                $text.val(oldtext);
            }
        }
        $text.prop("disabled", !active);
    }

    export function updateRblShowHide($rbl: JQuery, func) {
        const active = parseInt(<string> $rbl.filter(":checked").val()) != 0;
        func(active);
    }

    export function linkRblShowHide($rbl: JQuery, func) {
        updateRblShowHide($rbl, func);
        $rbl.on("click", function () {
            updateRblShowHide($rbl, func);
        });
    }

    export function updateRblText($rbl: JQuery, $text: JQuery) {
        const active = parseInt(<string> $rbl.filter(":checked").val()) != 0;
        updateTextActive($text, active);
    }

    export function linkRblText($rbl: JQuery, $text: JQuery) {
        updateRblText($rbl, $text);
        $rbl.on("click", function () {
            updateRblText($rbl, $text);
        });
    }

    export function updateCheckText($check: JQuery, $text: JQuery) {
        const active = $check.is(":checked");
        updateTextActive($text, active);
    }

    export function linkCheckText($check: JQuery, $text: JQuery) {
        updateCheckText($check, $text);
        $check.on("click", function () {
            updateCheckText($check, $text);
        });
    }

    export function updateCheckShowHide($check: JQuery, func) {
        let active = $check.is(":checked");
        func(active);
    }

    export function linkCheckShowHide($check: JQuery, func) {
        updateCheckShowHide($check, func);
        $check.on("click", function () {
            updateCheckShowHide($check, func);
        });
    }

    export function addTodayButton($txt: JQuery) {
        if ($txt.prop("disabled")) {
            return;
        }

        var $todayButton = $(
            "<input type='button' class='formbutton marginleft' value='Today' />",
        );
        $txt.after($todayButton);
        $todayButton.on("click", function () {
            $txt.val(getToday());
        });
    }
}
